export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/logo_animation.b978ba9.svg";